"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proto_generated_1 = require("./proto-generated");
exports.ApiTypes = proto_generated_1.wrapper.wix.social.groups.api;
exports.FeedApiTypes = proto_generated_1.wrapper.wix.feed;
exports.CommentsApiTypes = proto_generated_1.wrapper.wix.comments;
exports.ReactionsApiTypes = proto_generated_1.wrapper.wix.reactions;
exports.SocialApiTypes = proto_generated_1.wrapper.wix.social;
exports.CommonTypes = proto_generated_1.wrapper.wix.common;
//# sourceMappingURL=types.js.map